import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyAction, LazyModule, type LazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "MailRibbonLazyFunctions"*/ './lazyIndex'),
    { name: 'MailRibbonLazyFunctions' }
);

export const lazyGetAppCheckBoxControlRenderer: LazyAction<
    typeof lazyIndex.getDefaultCheckBoxRenderer,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getDefaultCheckBoxRenderer);

export const lazyGetAppComboBoxControlRenderer: LazyAction<
    typeof lazyIndex.getDefaultComboBoxRenderer,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getDefaultComboBoxRenderer);

export const LazyFromRefinerFlyoutContent: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.FromRefinerFlyoutContent
);

export const lazyResetFromRefinerFlyout: LazyAction<
    typeof lazyIndex.resetFromRefinerFlyoutMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.resetFromRefinerFlyoutMutator);

export const LazyToRefinerFlyoutContent: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    m => m.ToRefinerFlyoutContent
);

export const lazyResetToRefinerFlyout: LazyAction<
    typeof lazyIndex.resetToRefinerFlyoutMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.resetToRefinerFlyoutMutator);
